import {Injectable} from '@angular/core';
import {Apollo} from 'apollo-angular';
import {ALLANO, ANO} from '../queries/config.query';

@Injectable()
export class ConfigServices {

  constructor(private apollo:Apollo){

  }


  getConfig(id:number){

  }

  getAno(ano:number){
    return this.apollo.query<any>({
      query:ANO,
      variables:{
        ano:ano
      }
    });
  }

  getAnos(){
    return this.apollo.query<any>({
      query:ALLANO
    });
  }

}
